import { Navigate, useParams } from 'react-router-dom'
import { Construction } from 'lucide-react'
import { VENDORS } from 'features/Vendors/vendors'
import CenterCheckResource from './CenterCheckResource'

// Vendors with a page. Any other listed vendor shows as coming soon.
const VENDOR_PAGES: Record<string, () => JSX.Element> = {
	centercheck: CenterCheckResource,
}

const VendorResource = () => {
	const { vendorId } = useParams<{ vendorId: string }>()
	const vendor = VENDORS.find(v => v.id === vendorId)

	// Back to the Resources index, which opens the first vendor.
	if (!vendor) return <Navigate to=".." replace />

	const Page = VENDOR_PAGES[vendor.id]
	if (Page) return <Page />

	return (
		<div className="flex flex-col items-center justify-center py-12 text-center">
			<div className="mb-4 rounded-full bg-gray-100 p-3">
				<Construction className="h-6 w-6 text-gray-400" />
			</div>
			<h3 className="mb-1 text-lg font-medium text-gray-900">{vendor.name} is coming soon</h3>
			<p className="max-w-sm text-sm text-gray-500">This integration is under construction.</p>
		</div>
	)
}

export default VendorResource
